import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — the dome roof: a 2x2-tile cap for churches and civic
// buildings. A low pale-stone drum carries a muted patina-green hemisphere
// (a sphere whose lower half hides inside the drum) topped by a small
// finial spike. Authored at y=0; the consumer lifts it onto 2.6 m walls.
const STONE = "#c9c2b6";
const STONE_DARK = "#b8b2a8";
const PATINA = "#7fa88f";
const STEEL = "#aab2b8";

const R = 0.95;
const DRUM_H = 0.5;

export const domeRoof = defineModel({
  id: "dome-roof",
  batchId: "modern",
  name: "Dome roof",
  tags: ["modern", "outdoor", "structure", "roof", "church", "civic"],
  summary: "A 2x2 patina-green dome on a pale stone drum, with a finial.",
  description:
    "The dome cap of the Modern Living kit: a 1.9 m diameter patina-green " +
    "dome on a low pale-stone drum, topped by a steel finial spike. Suits " +
    "churches and civic buildings. Occupies 2x2 tiles; authored at y=0 and " +
    "lifted onto 2.6 m walls by the consumer.",
  tiles: { w: 2, h: 2 },
  footprint: 1.6,
  parts(): Part[] {
    return [
      // Drum with a slightly wider cornice ring at its top.
      { geometry: new THREE.CylinderGeometry(R, R, DRUM_H, 20), color: STONE, position: [0, DRUM_H / 2, 0] },
      { geometry: new THREE.CylinderGeometry(R + 0.04, R + 0.04, 0.08, 20), color: STONE_DARK,
        position: [0, DRUM_H - 0.04, 0] },
      // The dome: the top hemisphere of a sphere seated on the drum rim.
      { geometry: new THREE.SphereGeometry(R, 20, 10, 0, Math.PI * 2, 0, Math.PI / 2),
        color: PATINA, position: [0, DRUM_H, 0] },
      // Finial: a thin shaft and a spike at the apex.
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 0.16, 8), color: STEEL,
        position: [0, DRUM_H + R + 0.07, 0] },
      { geometry: new THREE.ConeGeometry(0.06, 0.22, 8), color: STEEL,
        position: [0, DRUM_H + R + 0.25, 0] },
    ];
  },
  animations: [],
});
